
import Vue from "vue";
import SongWithSort from "../models/SongWithSort";
import TopSelector from "../models/TopSelector";

const TOP_COUNT = 10;
const GROUP_SIZE = 4;
const COLUMNS = 2;

interface DataType {
  selector: TopSelector;
  group: SongWithSort[];
  count: number;
}

export default Vue.extend({
  name: "CompareSongs",
  // songs は全体ランキング順など、好みが近いと思われる順に並べて渡す（シード）。
  props: ["title", "songs"],
  data(): DataType {
    const songs = this.songs.map(v => new SongWithSort(v));
    const selector = new TopSelector(songs, TOP_COUNT, GROUP_SIZE);
    return {
      selector,
      group: selector.isFinished() ? [] : selector.next(),
      count: 1,
    };
  },
  computed: {
    rows(): SongWithSort[][] {
      const rows: SongWithSort[][] = [];
      for (let i = 0; i < this.group.length; i += COLUMNS) {
        rows.push(this.group.slice(i, i + COLUMNS));
      }
      return rows;
    },
  },
  mounted() {
    if (this.selector.isFinished()) {
      this.finish();
    }
  },
  methods: {
    select(winner: SongWithSort) {
      console.log(`第${this.count}試合 ${winner.name} wins`);
      this.count++;
      this.selector.select(winner);
      if (this.selector.isFinished()) {
        this.finish();
        return;
      }
      this.group = this.selector.next();
    },
    finish() {
      this.$emit("finish", this.selector.result().map(v => v.song));
    },
  },
});

